fragment flexibleHelpCards on flexibleSections_helpCards_BlockType {
    title: plaintext
    description: richTextMinimal
    helpCards {
        ... on page_Entry {
            label: title
            icon
            dateUpdated
            isLastUpdatedRelevant: plainSwitch
            description: plaintext
            uri
        }

        ... on subsidy_Entry {
            label: title
            icon
            dateUpdated
            isLastUpdatedRelevant: plainSwitch
            description: plaintext2
            uri
        }

        ... on informationPage_Entry {
            label: title
            icon
            dateUpdated
            isLastUpdatedRelevant: plainSwitch
            description: plaintext
            uri
            url
        }

        ... on externalLinks_default_Entry {
            label: plaintext
            icon
            description: textarea
            externalUrl
        }

        ... on postsOverview_Entry {
            label: title
            uri
        }
    }
}
